<div class="relative">
  <label
    class="absolute transition-all duration-200 pointer-events-none"
    [ngClass]="{
      '-top-4 left-0 text-sm text-primary': isOpen || value,
      'top-2 left-3 text-base text-gray-400': !isOpen && !value
    }"
  >
    {{ placeholder }}
  </label>
  <div
    class="bg-white border border-gray-300 rounded px-4 py-2 flex justify-between items-center cursor-pointer h-10"
    (click)="!isDisabled && toggleDropdown()"
    [ngClass]="{
      'cursor-not-allowed bg-gray-100 text-gray-400': isDisabled,
      'cursor-pointer': !isDisabled
    }"
  >
    <span class="text-gray-700">
      {{ selectedLabel !== placeholder ? selectedLabel : '' }}
    </span>
    <svg
      class="w-4 h-4 text-gray-500 ml-2 transition-transform"
      [ngClass]="{ 'rotate-180': isOpen }"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
    </svg>
  </div>

  @if (isOpen) {
  <div
    class="absolute mt-1 w-full bg-white border border-gray-300 rounded shadow z-10 max-h-60 overflow-auto"
  >
    @for (option of options; track $index) {
    <div
      class="px-4 py-2 hover:bg-secondary cursor-pointer"
      [ngClass]="{ 'bg-foreground text-white font-semibold': value === option.value }"
      (click)="selectOption(option)"
    >
      {{ option.label }}
    </div>
    }
  </div>
  }
</div>
